var XPortal = XPortal || {};
XPortal.Tabs = (function () {
    var self = {
        TabTimeout: null,
        Init: function (selector, settingsObj) {
            selector = selector ? selector : ".xportal-tabstrip";
            $(selector).each(function () {
                self.initFor(this, settingsObj, defaults)
            });

            $('.page-content').on('click', '.nav-tabs a', function () {
                var $this = $(this);

                var id = $this.attr('id');
                var $section = $('[aria-labelledby="' + id + '"]');

                self.ResizeContent($section, 200);
            });
            XPortal.Tabs.TabHeaders.Init();
        },
        TabHeaders: {
            Timeout: null,
            ScrollCntSelector: '.content-wrapper',
            ScrollCntMobileSelector: '.page-content',
            Init: function () {
                $('.content-wrapper').on('click', '.choose-section-link', function () {
                    var sectionId = $(this).attr('id').replace('tabitma-', '').replace('item-', '');
                    $('header a[data-tab-id]').removeClass('active');
                    var $link = $('header a[data-tab-id="' + sectionId + '"]');
                    if ($link.length) {
                        $link.addClass('active');
                    }
                });

                $('header').on('click', 'a[data-tab-id]', function () {
                    var $this = $(this);
                    var sectionId = $this.attr('data-tab-id');
                    var delay = 0;
                    //check for 'dropdown' ot 'tabs' view type
                    var $ddLink = $('#item-' + sectionId + '.choose-section-link, #tabitma-' + sectionId + '.choose-section-link');
                    if ($ddLink.length) {
                        $ddLink.click();
                        delay = 150;
                    }

                    var $section = $('[data-edit-id="' + sectionId + '"]');
                    $('header a[data-tab-id]').removeClass('active');
                    $this.addClass('active');

                    XPortal.Tabs.TabHeaders.ScrollToSection($section, delay);
                });

                $(XPortal.Tabs.TabHeaders.ScrollCntSelector).on('scroll.tabs', function () {
                    var $cnt = $(this);
                    clearTimeout(XPortal.Tabs.TabTimeout);
                    XPortal.Tabs.TabTimeout = setTimeout(function () {
                        $('header a[data-tab-id]').each(function () {
                            var $this = $(this);
                            var $section = $('[data-edit-id="' + $this.attr('data-tab-id') + '"]');
                            if ($section.length && XPortal.Utils.isElementInView($section, $cnt, false, 80, 0)) {
                                $('header a[data-tab-id]').removeClass('active');
                                $this.addClass('active');
                                return false;
                            }
                        });
                    }, 100);
                });

                $('body')
                    .on('click', '.nav-tabs-wizard .nav-link', function () {
                        $(this).closest('.slick-track').find('.nav-link').removeClass('active').removeClass('show');
                    })
                    .on('shown.bs.tab', '.nav-tabs > .nav-item > .nav-link', function (event) {
                        var tabId = $(this).attr('href');
                        var $tab = $(tabId);
                        XPortal.Measure.reInit($tab);
                        XPortal.DropdownBtns.gridButtons.check($tab);
                        setTimeout(function () { 
                            var $grid = $tab.find('.k-grid');
                            $grid.each(function () {
                                $(this).data('kendoGrid').refresh();
                            });
                        }, 100);
                        var $scheduler = $tab.find('.k-scheduler');
                        $scheduler.each(function () { 
                            XPortal.Calendar.recalculate($(this));
                        });
                        var $slider = $tab.find('.slick-slider.slick-initialized');
                        $slider.each(function () {
                            $(this).slick('refresh');
                        });
                    });

                XPortal.Tabs.TabHeaders.InitSlider();
                $(window).on('resize.tabs orientationchange.tabs', function () {
                    clearTimeout(XPortal.Tabs.TabHeaders.Timeout);
                    XPortal.Tabs.TabHeaders.Timeout = setTimeout(function () {
                        XPortal.Tabs.TabHeaders.InitSlider();
                    }, 150);
                });
            },
            ScrollToSection: function ($section, delay) {
                setTimeout(function () {
                    XPortal.Utils.ScrollTo(
                        XPortal.Utils.getViewportWidth() >= 768 ? $(XPortal.Tabs.TabHeaders.ScrollCntSelector) : $(XPortal.Tabs.TabHeaders.ScrollCntMobileSelector),
                        $section
                    );

                    $('body').removeClass('mobile-menu-opened');
                }, delay);
            },
            InitSlider: function () {
                $('.tabs-header, .nav-tabs-wizard').each(function () {
                    if (XPortal.Tabs.TabHeaders.IsNeedSlider($(this))) {
                        $(this).not('.slick-slider').slick({
                            speed: 300,
                            infinite: false,
                            slidesToShow: 1,
                            useTransform: true,
                            variableWidth: true
                        });
                    } else if ($(this).hasClass('slick-slider')) {
                        $(this).slick('unslick');
                    }
                });
            },
            IsNeedSlider: function ($wrapper) {
                var childrenWidth = 0;
                $wrapper.find('.tabs-header-item, .nav-item').each(function () {
                    childrenWidth += $(this).outerWidth();
                });

                return childrenWidth > $wrapper.width();
            }
        },
        ResizeContent: function ($section, timeOut) {
            var doResizeContent = function () {
                var $grid = $section.find(".k-grid");
                if ($grid.length) {
                    XPortal.DropdownBtns.gridButtons.check($grid);
                    $grid.each(function () {
                        XPortal.Grid.ResizeGrid($(this));
                    });
                }

                var $chart = $section.find(".k-chart");
                if ($chart.length) {
                    $chart.each(function () {
                        XPortal.Chart.ResizeChart($(this));
                    });
                }

                var $slider = $section.find('.slick-initialized');
                if ($slider.length) {
                    $slider.each(function () {
                        $(this).slick('setPosition');
                    });
                }
            };

            timeOut > 0 ? setTimeout(function () { doResizeContent(); }, timeOut) : doResizeContent();
        },
        initFor: function (selector, settings, _defaults) {
            var attr = $(selector).attr("data-tab") ? JSON.parse($(selector).attr("data-tab")) : {};
            var result = jQuery.extend(true, {}, _defaults, attr, settings);

            var r = $(selector).kendoTabStrip(result);
            if (r.attr("data-active")) r.data("kendoTabStrip").activateTab($(r.attr("data-active")));
            var selTabIndex = Number(r.attr("data-select"));
            if (selTabIndex >= 0) r.data("kendoTabStrip").select(selTabIndex);
            return r;
        }
    };
    var defaults = {
        scrollable: true, navigatable: true, collapsible: false, animation: {
            close: {
                duration: 200,
                effects: "fadeOut"
            },
            open: {
                duration: 100,
                effects: "fadeIn"
            }
        }
    };
    return self;
}());
